export const columnData = [
  {
    code: 'RT.02.01.0020',
    name: 'Type of contractual arrangements',
  },
  {
    code: 'RT.02.01.0020',
    name: 'Type of contractual arrangements',
  },
  {
    code: 'RT.02.01.0020',
    name: 'Type of contractual arrangements',
  },
  {
    code: 'RT.02.01.0020',
    name: 'Type of contractual arrangements',
  },
  {
    code: 'RT.02.01.0020',
    name: 'Type of contractual arrangements',
  },
  {
    code: 'RT.02.01.0170',
    name: 'Impact of discontinuing the function',
  },
  {
    code: 'RT.02.01.0170',
    name: 'Impact of discontinuing the function',
  },
  {
    code: 'RT.02.01.0170',
    name: 'Impact of discontinuing the function',
  },
  {
    code: 'RT.02.01.0170',
    name: 'Impact of discontinuing the function',
  },
  {
    code: 'RT.02.01.0170',
    name: 'Impact of discontinuing the function',
  },
  {
    code: 'RT.02.01.0170',
    name: 'Impact of discontinuing the function',
  },
  {
    code: 'RT.06.01.0110',
    name: 'Impact of discontinuing the ICT services',
  },
  {
    code: 'RT.06.01.0110',
    name: 'Impact of discontinuing the ICT services',
  },
  {
    code: 'RT.06.01.0110',
    name: 'Impact of discontinuing the ICT services',
  },
  {
    code: 'RT.06.01.0110',
    name: 'Impact of discontinuing the ICT services',
  },
  {
    code: 'RT.06.01.0110',
    name: 'Impact of discontinuing the ICT services',
  },
  {
    code: 'RT.06.01.0110',
    name: 'Impact of discontinuing the ICT services',
  },
  {
    code: 'RT.07.01.0050',
    name: 'Possibility of reintegration of the contracted ICT service',
  },
  {
    code: 'RT.07.01.0050',
    name: 'Possibility of reintegration of the contracted ICT service',
  },
  {
    code: 'RT.07.01.0050',
    name: 'Possibility of reintegration of the contracted ICT service',
  },
  {
    code: 'RT.07.01.0090',
    name: 'Sensitiveness of the data stored by the ICT third-party service provider',
  },
  {
    code: 'RT.07.01.0090',
    name: 'Sensitiveness of the data stored by the ICT third-party service provider',
  },
  {
    code: 'RT.07.01.0090',
    name: 'Sensitiveness of the data stored by the ICT third-party service provider',
  },
  {
    code: 'RT.07.01.0090',
    name: 'Sensitiveness of the data stored by the ICT third-party service provider',
  },
  {
    code: 'RT.07.01.0090',
    name: 'Sensitiveness of the data stored by the ICT third-party service provider',
  },
  {
    code: 'RT.07.01.0090',
    name: 'Sensitiveness of the data stored by the ICT third-party service provider',
  },
  {
    code: 'RT.07.01.0090',
    name: 'Sensitiveness of the data stored by the ICT third-party service provider',
  },
  {
    code: 'RT.07.01.0100',
    name: 'Substitutability of the ICT third-party service provider',
  },
  {
    code: 'RT.07.01.0100',
    name: 'Substitutability of the ICT third-party service provider',
  },
  {
    code: 'RT.07.01.0100',
    name: 'Substitutability of the ICT third-party service provider',
  },
  {
    code: 'RT.07.01.0100',
    name: 'Substitutability of the ICT third-party service provider',
  },
  {
    code: 'RT.07.01.0100',
    name: 'Substitutability of the ICT third-party service provider',
  },
];

export const columnCodes = [
  '0010',
  '0020',
  '0030',
  '0040',
  '0050',
  '0060',
  '0070',
  '0080',
  '0090',
  '0100',
  '0110',
  '0120',
  '0130',
  '0140',
  '0150',
  '0160',
  '0170',
  '0180',
  '0190',
];

export const columnTitles = [
  'Low',
  'Medium',
  'High',
  'Low',
  'Medium',
  'High',
  'Easy',
  'Difficult',
  'Highly complex',
  'Low',
  'Medium',
  'High',
  'Standalone arrangement',
  'Overarching arrangement',
  'Subsequent or associated arrangement',
  'Medium complexity in terms of substitutability',
  'Easily substitutable',
  'Highly complex substitutability',
  'Not substitutable',
];

export const columnGroups = [
  {
    name: 'Impact of discontinuing the function',
    size: 3,
    key: 'impact_of_discontinuing_function',
  },
  {
    name: 'Impact of discontinuing the ict services',
    size: 3,
    key: 'impact_of_discontinuing_ict_services',
  },
  {
    name: 'Possibility of reintegration of the contracted ICT service',
    size: 3,
    key: 'possibility_of_reintegration',
  },
  {
    name: 'Sensitiveness of data stored by ict tpsp',
    size: 3,
    key: 'sensitiveness_of_data_stored_by_ict_tpsp',
  },
  {
    name: 'Type of contractual arrangement',
    size: 3,
    key: 'type_of_contractual_arrangement',
  },
  {
    name: 'Substitutability of the ICT third-party service provider',
    size: 4,
    key: 'substitutability_of_ict_provider',
  },
];
